import {
  GET_SOURCES_GLOBAIS_INIT,
  GET_SOURCES_GLOBAIS_SUCCESS,
  UPDATE_SOURCE_GLOBAL_ATIVO_INIT,
  UPDATE_SOURCE_GLOBAL_ATIVO_SUCCESS,
  ERROR_SOURCES_GLOBAIS_MSG,
  CLEAR_FLAGS_SOURCES_GLOBAIS
} from '../actionTypes';

export const getSourcesGlobaisInit = () => ({
  type: GET_SOURCES_GLOBAIS_INIT,
  payload: {}
});

export const getSourcesGlobaisSuccess = (data: any) => ({
  type: GET_SOURCES_GLOBAIS_SUCCESS,
  payload: data
});

export const atualizaSourceGlobalAtivoInit = (data: any) => ({
  type: UPDATE_SOURCE_GLOBAL_ATIVO_INIT,
  payload: data
});

export const atualizaSourceGlobalAtivoSuccess = (data: any) => ({
  type: UPDATE_SOURCE_GLOBAL_ATIVO_SUCCESS,
  payload: data
});

export const errorSourcesGlobaisMsg = (data: any) => ({
  type: ERROR_SOURCES_GLOBAIS_MSG,
  payload: data
});

export const clearFlagsSourcesGlobais = () => ({
  type: CLEAR_FLAGS_SOURCES_GLOBAIS,
  payload: {}
});
